import { BaseApi } from '@/main/baseApi';

import { CONTROLLER_NAME, DMS_MODULE, NAME } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, CONTROLLER_NAME, NAME);
